import {generateRouteTo} from 'epic-fortnite-react';
import classNames from 'classnames';
import epicTracking from 'epic-tracking';
import PropTypes from 'prop-types';
import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import root from 'window-or-global';

/**
 * Client Download Page.
 */

const trackDownloadClick = (platform) => {
  epicTracking.trackEvent('Interaction', {
    interactionType: 'click',
    eventCategory: 'downloadPage',
    eventAction: 'platformDownloadButton-CTA2',
    eventLabel: platform,
  });
};

class ClientDownload extends React.PureComponent {
  static propTypes = {
    supportedOS: PropTypes.array.isRequired,
    className: PropTypes.string,
    headerMsg: PropTypes.string.isRequired,
    mobileHeaderMsg: PropTypes.string.isRequired,
    iOSDownloadUnavailable: PropTypes.string.isRequired,
    bodyMsg: PropTypes.string.isRequired,
    selectMsg: PropTypes.string,
    pcDownloadUrl: PropTypes.string,
    macDownloadUrl: PropTypes.string,
    iosDownloadUrl: PropTypes.string,
    xboxLink: PropTypes.string,
    gfnLink: PropTypes.string,
    androidUrl: PropTypes.string,
    returnHomeMsg: PropTypes.string.isRequired,
    mobileMsg: PropTypes.string.isRequired,
    chooseAltPlatformMsg: PropTypes.string.isRequired,
    windowMsg: PropTypes.string,
    iosMsg: PropTypes.string,
    androidMsg: PropTypes.string,
    macMsg: PropTypes.string,
    alertJSX: PropTypes.element,
    showAlert: PropTypes.bool,
    legalTags: PropTypes.array,
    children: PropTypes.node,
  };

  componentDidMount() {
    // auto download the game on a supported platform
    if (this.props.supportedOS.indexOf('windows') !== -1 && root._epicGamesNav.browser.windows) {
      setTimeout(() => {
        if (this.props.pcDownloadUrl) {
          root.location = this.props.pcDownloadUrl;
        } else {
          console.info(
            'pcDownloadUrl is not provided, fail to start download client automatically on windows'
          );
        }
      }, 2000);
    }

    if (this.props.supportedOS.indexOf('mac') !== -1 && root._epicGamesNav.browser.mac) {
      setTimeout(() => {
        if (this.props.macDownloadUrl) {
          root.location = this.props.macDownloadUrl;
        } else {
          console.info(
            'macDownloadUrl is not provided, fail to start download client automatically on Mac'
          );
        }
      }, 2000);
    }
  }

  render() {
    const showWinBtn =
      this.props.supportedOS.indexOf('windows') !== -1 &&
      this.props.pcDownloadUrl &&
      this.props.windowMsg;
    const showMacBtn =
      this.props.supportedOS.indexOf('mac') !== -1 &&
      this.props.macDownloadUrl &&
      this.props.macMsg;
    const showiOSBtn =
      this.props.supportedOS.indexOf('iOS') !== -1 &&
      this.props.iosDownloadUrl &&
      this.props.iosMsg;
    const showAndroidBtn =
      this.props.supportedOS.indexOf('android') !== -1 &&
      this.props.androidUrl &&
      this.props.androidMsg;
    let isOSSupported = false;
    for (const os of this.props.supportedOS) {
      if (Object.keys(root._epicGamesNav.browser).indexOf(os) !== -1) {
        isOSSupported = true;
      }
    }
    const logoClass = classNames('gfnLogo', {fnMobile: this.props.fnMobile});
    let downloadBody = (
      <div>
        {this.props.showAlert && this.props.alertJSX}
        {isOSSupported ? <p>{this.props.bodyMsg}</p> : null}
        <div className="selectPlatform">{this.props.selectMsg}</div>
        <div className="downloadButtons">
          {showWinBtn ? (
            <a
              title={this.props.windowMsg}
              className="button"
              href={this.props.pcDownloadUrl}
              onClick={() => trackDownloadClick('windows')}>
              <i className="icon-windows" />
              <span>{this.props.windowMsg}</span>
            </a>
          ) : null}
          {showMacBtn ? (
            <a
              title={this.props.macMsg}
              className="button"
              href={this.props.macDownloadUrl}
              onClick={() => trackDownloadClick('mac')}>
              <i className="icon-mac-os" />
              <span>{this.props.macMsg}</span>
            </a>
          ) : null}
          {showiOSBtn ? (
            <a
              title={this.props.iosMsg}
              className="button"
              href={this.props.iosDownloadUrl}
              onClick={() => trackDownloadClick('iOS')}
              target="_blank"
              rel="noopener noreferrer">
              <i className="icon-iOS" />
              <span>{this.props.iosMsg}</span>
            </a>
          ) : null}
          {showAndroidBtn ? (
            <a
              title={this.props.androidMsg}
              className="button"
              href={this.props.androidUrl}
              onClick={() => trackDownloadClick('android')}>
              <i className="icon-android" />
              <span>{this.props.androidMsg}</span>
            </a>
          ) : null}
        </div>
      </div>
    );
    const legalTags = this.props.legalTags || [];
    const bottomImgs = [];
    if (legalTags.length) {
      legalTags.forEach((tag, index) => {
        const temp = (
          <li className="tag-container" key={tag.src}>
            <p className="tag-title accent-color">{tag.title}</p>
            <img className="bottomImg" alt={tag.title} src={tag.src} />
          </li>
        );
        bottomImgs.push(temp);
      });
    }
    if (root._epicGamesNav.browser.android) {
      downloadBody = showAndroidBtn ? (
        <div className="downloadButtons">
          <a
            title={this.props.androidMsg}
            className="button"
            href={this.props.androidUrl}
            onClick={() => trackDownloadClick('android')}>
            <i className="icon-android" />
            <span>{this.props.androidMsg}</span>
          </a>
        </div>
      ) : (
        <p className="mobileMsg">{this.props.mobileMsg}</p>
      );
    }

    const ios =
      root._epicGamesNav.browser.ios ||
      (root._epicGamesNav.browser.platform.vendor?.toLowerCase().match('apple') &&
        root.navigator.maxTouchPoints >= 1);

    return (
      <div className={this.props.className}>
        {this.props.children ? (
          <div className="download-header-container">{this.props.children}</div>
        ) : (
          <div>
            <h1 data-testid="download-header-msg">
              {ios ? this.props.mobileMsg : this.props.headerMsg}
            </h1>
            <div className="epicLogo" />
          </div>
        )}

        {ios ? (
          <>
            <h1>{this.props.chooseAltPlatformMsg}</h1>
            <div className="downloadButtons">
              <a
                className="button"
                href={this.props.xboxLink}
                onClick={() => trackDownloadClick('xbl')}>
                <i className="icon-xbox" />
                <span>{this.props.xboxMsg}</span>
              </a>
              <a
                className="button"
                href={this.props.gfnLink}
                onClick={() => trackDownloadClick('gfn')}>
                <i className={logoClass} />
              </a>
            </div>
          </>
        ) : (
          downloadBody
        )}
        <ul className="downloadLegalTags">{bottomImgs}</ul>
        <Link to={generateRouteTo('/', this.props.location)} className="returnLink">
          {this.props.returnHomeMsg}
        </Link>
      </div>
    );
  }
}
export default withRouter(ClientDownload);
